import { css } from "@emotion/react";

export const firstTableCellStyle = css`
  padding-left: 24px !important;
`;

export const cardBottomPadding = css`
  padding-bottom: 24px;
`;
